import React, { useEffect, useState, useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faChevronDown, faX, faPlus, faPen, faPaperPlane, faShareAlt, faEnvelope, 
  faSms, faEllipsisV, faDownload, faPrint // Added download and print icons
} from '@fortawesome/free-solid-svg-icons';
import { useLocation, useNavigate } from 'react-router-dom';
import  '../Css/Tooltip.css';
import {Loader, Spinner } from '../Loader/Loader';
import { Msg200or201, Msg204, Msg400, Msg401 ,Msg403, Msg500 } from '../Messages/Messages';
import { PDFDownloadLink } from '@react-pdf/renderer';
import useCommonResponseHandler from '../CommenResponseAndErrorHandlers/CommenResponseHandler';
import PurchaseOrderPdfViewer from './PurchaseOrderPdfViewer';
import useAutoScroll from '../Components/UseAutoScroll';
import { decryptData } from '../../utils/storageCrypto';
import html2canvas from 'html2canvas'; // Imported for exact screen capture
import { jsPDF } from 'jspdf'; // Imported for PDF generation

const PurchaseOrderDetails = () => {
  const navigate = useNavigate ();
  const location = useLocation();
  const { PurchaseOrderData } = location.state || {}; 
  console.log(PurchaseOrderData);
  const [PurchaseOrders , setPurchaseOrders] = useState ([]);
  const [SelectedPurchaseOrder, setSelectedPurchaseOrder] = useState(null);
  const RETRY_LIMIT = 3; // Maximum number of retries
  const [retryCount, setRetryCount] = useState(0); // Track retry attempts
  const [isLoading, setIsLoading] = useState(true);
  const [showSendOptions, setShowSendOptions] = useState(false);
  
  const [showConvertPopup, setShowConvertPopup] = useState(false);
  const [PurchaseorderId, setPurchaseorderId] = useState(null);
  console.log(PurchaseorderId);
  const [Items , setItems] = useState();
  const { 
    showPopup, popupMessage, popupType, retryFunction,
    isSaving ,setPopupMessage,setPopupType,handleGetResponse, handleSaveResponse, setShowPopup,
    setRetryFunction, handleDeleteResponse, setIsSaving  } = useCommonResponseHandler();
  
  const [roleId, setRoleId] = useState(null);
  const sendOptionsRef = useRef(null);
  const itemRefs = useRef({});
  const listContainerRef = useRef(null);
  
  // Reference for the element we want to print/download
  const purchaseOrderRef = useRef(null);

  const useOutsideClick = (ref, callback) => {
    const handleClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        callback();
      }
    };
    React.useEffect(() => {
      document.addEventListener('click', handleClick);
      return () => {
        document.removeEventListener('click', handleClick);
      };
    }, []);
  };
    
  useOutsideClick(sendOptionsRef, () => setShowSendOptions(false));
  
  useEffect(() => {
    fetchRoleId();
    fetchPurchaseOrder(PurchaseOrderData);
  }, [PurchaseOrderData]);

  useAutoScroll({
    selectedItem: SelectedPurchaseOrder,
    itemRefs,
    containerRef: listContainerRef,
  });

  const fetchRoleId = () => {
    const encryptedroleId = sessionStorage.getItem('roleId');
    const sroleId = decryptData(encryptedroleId);
    setRoleId(sroleId);
  };
    
  const PurchaseOrdersToDisplay = PurchaseOrders && roleId === 6 
    ? PurchaseOrders.filter(PurchaseOrder => (PurchaseOrder.product_category_id?.product_category_name.toLowerCase()) === 'tiles')
    : PurchaseOrders ||[];
  console.log(PurchaseOrdersToDisplay);
    
  const fetchPurchaseOrder = async (selectedPurchaseOrder, attempt = 0) => {
    console.log(selectedPurchaseOrder)
    try {
      const encryptedToken = sessionStorage.getItem('token');
      const token = decryptData(encryptedToken);
      const encryptedhubId = sessionStorage.getItem('hubId');
      const hubId = decryptData(encryptedhubId);
      const response = await fetch(`${process.env.REACT_APP_FORE_BRICKBUCKET}customer/purchaseorder/get-all-purchaseorders?hubId=${hubId}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'x-token': token,
        },
      });

      const data = await response.json();
      console.log(data)
      if (response.ok) {
        setPurchaseOrders(data.data);
        setSelectedPurchaseOrder(selectedPurchaseOrder);
        handlePurchaseOrderClick(selectedPurchaseOrder);
      } else {
        console.error(data.message);
      }
    
      if (response.status === 500) {
        setRetryFunction(() => () => fetchPurchaseOrder(attempt));
      }
    } catch (error) {
      console.error('Failed to fetch purchase orders:', error);

      if (attempt < RETRY_LIMIT) {
        setRetryCount(attempt + 1);
        setTimeout(() => fetchPurchaseOrder(attempt + 1), 1000);
      } else {
        setIsLoading(false);
        setPopupMessage('Internal Server Error. Kindly Retry.');
        setPopupType('500');
        setShowPopup(true);
        setRetryFunction(() => () => fetchPurchaseOrder(attempt));
      }
    } finally {
      setIsLoading(false);
    }
  }; 

  const fetchPurchaseOrdersbyId = async (id, attempt = 0) => {
    try {
      const encryptedToken = sessionStorage.getItem('token');
      const token = decryptData(encryptedToken);

      const response = await fetch(`${process.env.REACT_APP_FORE_BRICKBUCKET}customer/purchaseorder/get-purchaseorder?purchaseorder_id=${id}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'x-token': token,
        },
      });

      const data = await response.json();
      console.log(data);
      const output =  await handleGetResponse(response, data)
      if(output){
        console.log(output)
        setSelectedPurchaseOrder(output);
      } else {
      
      }
    } catch (error) {
      console.error('Failed to fetch:', error);

      if (attempt < RETRY_LIMIT) {
        setRetryCount(attempt + 1); 
        setTimeout(() => fetchPurchaseOrdersbyId(id, attempt + 1), 1000); 
      } else {
        setIsLoading(false);
        setPopupMessage('Internal Server Error. Kindly Retry.');
        setPopupType('500');
        setShowPopup(true);
        setRetryFunction(() => () => fetchPurchaseOrdersbyId(id, attempt)); 
      }
    } finally {
      
    }
  };
    
  const handlePurchaseOrderClick = (PurchaseOrder) => {
    setPurchaseorderId(PurchaseOrder?._id);
    setSelectedPurchaseOrder(PurchaseOrder);
    fetchPurchaseOrdersbyId(PurchaseOrder?._id);
    console.log(PurchaseOrder);
  }

  const handleClose = () => {
    navigate('/admin/app/purchases/purchaseorderlist');
  }

  if (isLoading) {
    return <Loader />;
  }

  const handleCreatePurchaseOrder = () => {
    navigate("/admin/app/purchases/newpurchaseorder");
  }

  const handleEdit = () => {
    navigate('/admin/app/purchases/editpurchaseorder', {state:{PurchaseOrderID: PurchaseorderId}});
    console.log(PurchaseorderId);
  }

  const handleSendClick = () => {
    setShowSendOptions(!showSendOptions);
  };

  // --- NEW DOWNLOAD LOGIC ---
  const handleDownload = async () => {
    const element = purchaseOrderRef.current;
    if (!element) return;

    try {
      const canvas = await html2canvas(element, { scale: 2, useCORS: true });
      const imgData = canvas.toDataURL('image/png');
      
      const pdf = new jsPDF('p', 'mm', 'a4');
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
      
      pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
      pdf.save(`purchase_order_${SelectedPurchaseOrder?.purchaseorder_number}.pdf`);
    } catch (error) {
      console.error('Failed to generate PDF:', error);
    }
  };

  // --- NEW PRINT LOGIC ---
  const handlePrint = async () => {
    const element = purchaseOrderRef.current;
    if (!element) return;

    try {
      const canvas = await html2canvas(element, { scale: 2, useCORS: true });
      const imgData = canvas.toDataURL('image/png');

      const iframe = document.createElement('iframe');
      iframe.style.display = 'none';
      document.body.appendChild(iframe);

      iframe.contentWindow.document.open();
      iframe.contentWindow.document.write(`
        <html>
          <head>
            <style>
              @page { margin: 0; }
              body { margin: 0; display: flex; justify-content: center; background: white; }
              img { max-width: 100%; height: auto; }
            </style>
          </head>
          <body>
            <img src="${imgData}" />
          </body>
        </html>
      `);
      iframe.contentWindow.document.close();

      iframe.onload = () => {
        iframe.contentWindow.focus();
        iframe.contentWindow.print();
        setTimeout(() => document.body.removeChild(iframe), 1000);
      };
    } catch (error) {
      console.error('Failed to print document:', error);
    }
  };
  
  const sendPurchaseOrderToUser = async () => {
    setIsSaving(true);
    setShowSendOptions(false);
    try {
      const encryptedToken = sessionStorage.getItem('token');
      const token = decryptData(encryptedToken);

      const response = await fetch(`${process.env.REACT_APP_FORE_BRICKBUCKET}customer/purchaseorder/send-purchaseorder-to-user`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-token': token,
        },
        body: JSON.stringify({
          vendorId: SelectedPurchaseOrder.vendor_id._id,
          documentType: 'Purchase Order',
          documentData: {
            documentNumber: SelectedPurchaseOrder.purchaseorder_number,
            date: SelectedPurchaseOrder.purchaseorder_date,
            status: SelectedPurchaseOrder.purchaseorder_status,
            items: SelectedPurchaseOrder.items.map(item => ({
              item_name: item.item_name,
              quantity: item.quantity,
              UOM: item.UOM,
              price: item.cost_price,
              tax_rate: item.tax_rate,
              total: item.total
            })),
            additionalInfo: {
              'Sub Total': SelectedPurchaseOrder.subtotal,
              'Tax': SelectedPurchaseOrder.tax_amount,
              'Total': SelectedPurchaseOrder.total
            }
          }
        }),
      });

      const data = await response.json();

      if (data.success) {
        setPopupMessage('Purchase Order sent successfully');
        setPopupType('200or201');
        setTimeout(() => {
          setShowPopup(false);
          setPopupMessage('');
          setPopupType('');
        }, 2000);
      } else {
        if (response.status === 400) {
          setPopupType('400');
          setPopupMessage(data.message);
          setShowPopup(true);
          return null
        } else if (response.status === 401) {
          setPopupType('401');
          setPopupMessage(data.message);
          setShowPopup(true);
          return null
        } else if (response.status === 403) {
          setPopupType('403');
          setPopupMessage(data.message);
          setShowPopup(true);
          return null
        } else if (response.status === 404) {
          setPopupType('404');
          setPopupMessage(data.message);
          setShowPopup(true);
          return null
        }
      }
    } catch (error) {
      console.error('Error sending purchase order:', error);
      setPopupMessage('Failed to send purchase order');
      setPopupType('400');
      setShowPopup(true);
    } finally {
      setIsSaving(false);
    }
  };

  const closePopup = () => {
    console.log("closePopup called");
    setShowPopup(false);
    setPopupMessage('');
    setPopupType('');
  };

  const BackToLoginPage = () => {
    console.log("Back To Login Page");
    setShowPopup(false);
    localStorage.removeItem('LoginData');
    sessionStorage.removeItem('userData');
    sessionStorage.removeItem('token');
    sessionStorage.removeItem('userId');
    sessionStorage.removeItem('appId');
    navigate('/admin/admin');
  };

  const Retry = async() => {
    console.log("Retry called");
    setTimeout(async () => {
      if(retryFunction){
        await retryFunction ();
      }
      setIsLoading(false)
    }, 1000)
    
    setShowPopup(false);
  };

  return (
    <div className=" bg-white flex flex-row w-full justify-center overflow-y-hidden">
      {/* List of Vendors Div start */}
      <div className=" flex flex-col w-[32%] ">
        <div className="p-4 border-b flex flex-row justify-between ">
          <div>
            <h5 className="text-md font-semibold cursor-pointer ">All Purchase Orders
              <FontAwesomeIcon icon={faChevronDown} className="text-xs mb-0.5 text-blue-600 mx-1 cursor-pointer " />
            </h5>
          </div>
          <div className=''>
            <button onClick={handleCreatePurchaseOrder}
              className="mr-2 bg-[#f7525a] text-white px-1 py-0.5 rounded-md" data-tooltip="Create Purchase Orders" title="" style={{ '--tooltip-bg': 'black' }}>
              <FontAwesomeIcon icon={faPlus} className="mb-0.5 text-xs text-white mx-1 cursor-pointer" />
            </button>
          </div>
        </div>

        <div className="flex justify-center overflow-y-hidden flex-col">
          <div className="flex flex-col h-[80vh] overflow-y-auto" ref={listContainerRef}>
            {PurchaseOrdersToDisplay.map((PurchaseOrder, index) => (
              <div
                key={PurchaseOrder._id}
                ref={(el) => (itemRefs.current[PurchaseOrder._id] = el)}
                className={`border-b text-sm flex items-center px-4 py-2 ${PurchaseorderId === PurchaseOrder._id ? 'bg-gray-100' : ''} hover:bg-gray-100 cursor-pointer`}
                onClick={() => handlePurchaseOrderClick(PurchaseOrder)}
              >
                <div className="flex flex-row">
                  <div>
                    <input
                      type="checkbox"
                      className="mr-2 w-3 h-3 accent-blue-600 cursor-pointer"
                    />          
                  </div>
                  <div className="flex flex-col">
                    <p className="text-md font-semibold">{PurchaseOrder.purchaseorder_number}</p>
                    <p className="text-gray-600 text-sm flex items-center">
                      {PurchaseOrder?.status} 
                      <span className="mx-1 text-gray-600">&middot;</span>
                      {new Date(PurchaseOrder.purchaseorder_date).toLocaleDateString()} 
                    </p>
                    <p className="text-gray-600 text-sm"></p>
                  </div>
                </div>
              </div>
            ))} 
          </div>
        </div>
      </div>
      {/* List of Vendors Div end */}

      <div className="border-l w-full flex flex-col ">
        <div className="border-l w-full flex flex-col">
          <div className="border-b h-30">
            <div className="p-4 flex justify-between items-center">
              <span className="text-md font-semibold">{SelectedPurchaseOrder?.purchaseorder_number}</span> 
              <button className="text-white px-1 py-1 rounded-md">
                <FontAwesomeIcon icon={faX} onClick={handleClose} className="text-[#f7525a] text-sm mx-2 cursor-pointer" />
              </button>
            </div>
            
            <div className="flex items-center px-2 bg-[#F9F9FB] border-t">
              <button className="border-r px-4 py-2 text-sm mr-2" onClick={handleEdit}>
                <FontAwesomeIcon icon={faPen} className="mr-2 w-3 h-3" />
                Edit
              </button>
              <div ref={sendOptionsRef} className="relative">
                <button 
                  onClick={handleSendClick} 
                  className={`px-4 py-2 border-r text-sm mr-2 ${isSaving ? 'cursor-not-allowed opacity-50' : ''}`}
                  disabled={isSaving}
                >
                  <div className="flex items-center justify-center space-x-2">
                    <FontAwesomeIcon icon={faPaperPlane} className="mr-1 w-3 h-3" />
                    <span>Send</span> {isSaving && <Spinner />}
                  </div>
                </button>
                {showSendOptions && (
                  <div className="p-0.5 absolute left-0 top-full mt-1 bg-white border rounded shadow-lg z-10">
                    <button onClick={sendPurchaseOrderToUser} className="text-sm hover:bg-blue-500 hover:text-white text-center hover:rounded-md p-1 w-full">
                      <FontAwesomeIcon icon={faEnvelope} className="mr-2" />
                      Email
                    </button>
                    <button className="text-sm hover:bg-blue-500 hover:text-white text-center hover:rounded-md p-1 w-full">
                      <FontAwesomeIcon icon={faSms} className="mr-2" />
                      SMS
                    </button>
                  </div>
                )}
              </div>

              {/* Exact Screen Download Button */}
              {SelectedPurchaseOrder && (
                <button 
                  onClick={handleDownload} 
                  className="text-sm px-4 border-r py-2 mr-2 hover:bg-gray-100 flex items-center"
                >
                  <FontAwesomeIcon icon={faDownload} className="mr-2 w-3 h-3" />
                  Download
                </button>
              )}

              {/* Exact Screen Print Button */}
              {SelectedPurchaseOrder && (
                <button 
                  onClick={handlePrint} 
                  className="text-sm px-4 border-r py-2 mr-2 hover:bg-gray-100 flex items-center"
                >
                  <FontAwesomeIcon icon={faPrint} className="mr-2 w-3 h-3" />
                  Print
                </button>
              )}

            </div>
          </div>
          
          <div className="w-full h-full bg-white rounded-xs overflow-hidden">
            <div className="flex flex-col h-[80vh] overflow-hidden">
              <div className="overflow-y-auto flex-1 p-6">
                {/* "What's Next?" section */}
                {SelectedPurchaseOrder && (
                  <>
                    <h1 className="text-lg mt-4 px-4 font-semibold mb-0">{SelectedPurchaseOrder?.status}</h1>
                    
                    {/* Wrap the PurchaseOrderPdfViewer inside a div containing the ref for screenshot */}
                    <div className="mt-4 bg-white" ref={purchaseOrderRef} style={{ padding: '20px' }}>
                      <PurchaseOrderPdfViewer purchaseorder={SelectedPurchaseOrder} /> 
                    </div>
                  </>
                )} 
              </div>
            </div>
          </div>
        </div>
      </div>
      
      {showPopup && (
        <div>
          {popupType === '200or201' && <Msg200or201 message={popupMessage} timeout={3000} />}
          {popupType === '204' && <Msg204 message={popupMessage} timeout={3000} />}
          {popupType === '400' && <Msg400 message={popupMessage} closePopup={closePopup} />}
          {popupType === '401' && <Msg401 message={popupMessage} closePopup={closePopup} />}
          {popupType === '403' && <Msg403 message={popupMessage} closePopup={BackToLoginPage} />}
          {popupType === '500' && <Msg500 message={popupMessage} closePopup={Retry} cancelPopup={closePopup}/>}
        </div>
      )}
   </div>
  );
};

export default PurchaseOrderDetails;